import { ApplicationRef, ComponentRef, Injectable, Injector, Type, createComponent } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DropdownOverlayService {
  private overlayRef: ComponentRef<any> | null = null;

  constructor(private appRef: ApplicationRef, private injector: Injector) {}

  attach<T extends object>(component: Type<T>, props: Partial<T> = {}): ComponentRef<T> {
    console.log('Overlay attach', component, props);
    this.detach();
    const cmpRef = createComponent(component, { environmentInjector: this.appRef.injector });
    console.log('[Overlay] Created component:', cmpRef);
    // Set all input properties
    Object.keys(props).forEach(key => {
      if (key in cmpRef.instance) {
        (cmpRef.instance as any)[key] = (props as any)[key];
      }
    });
    // Subscribe to outputs if EventEmitter
    if ((cmpRef.instance as any).itemSelected && typeof (props as any).itemSelected === 'function') {
      (cmpRef.instance as any).itemSelected.subscribe((props as any).itemSelected);
    }
    if ((cmpRef.instance as any).closeMenu && typeof (props as any).closeMenu === 'function') {
      (cmpRef.instance as any).closeMenu.subscribe((props as any).closeMenu);
    }
    this.appRef.attachView(cmpRef.hostView);
    console.log('[Overlay] rootNodes before append:', (cmpRef.hostView as any).rootNodes);
    document.body.appendChild((cmpRef.hostView as any).rootNodes[0]);
    console.log('[Overlay] rootNode appended to body.');
    if (cmpRef.changeDetectorRef) {
      cmpRef.changeDetectorRef.detectChanges();
      console.log('[Overlay] changeDetectorRef.detectChanges() called');
    }
    this.overlayRef = cmpRef;
    console.log('[Overlay] overlayRef assigned:', this.overlayRef);
    return cmpRef;
  }

  detach() {
    if (this.overlayRef) {
      this.appRef.detachView(this.overlayRef.hostView);
      this.overlayRef.destroy();
      this.overlayRef = null;
    }
  }
}
